import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";

interface Props {
  selectedTab: TabNames;
  total: number;
  copied: number;
  failed: number;
  setSelectedTab: (value: TabNames) => void;
}
const ResultButtonGroup = ({ selectedTab, copied, failed, total, setSelectedTab }: Props) => {
  return (
    <ToggleButtonGroup
      fullWidth
      sx={{
        height: 30,
        ".MuiToggleButton-root.Mui-selected": {
          backgroundColor: "action.hover",
        },
      }}
      value={selectedTab}
      exclusive
      onChange={(_, value: TabNames) => value && setSelectedTab(value)}
    >
      <ToggleButton value="all" sx={{ gap: 1 }}>
        All <BadgeDetached color="secondary" showZero badgeContent={total} />
      </ToggleButton>
      <ToggleButton value="copied" sx={{ gap: 1 }}>
        Copied <BadgeDetached color="secondary" showZero badgeContent={copied} />
      </ToggleButton>
      <ToggleButton value="failed" sx={{ gap: 1 }}>
        Failed <BadgeDetached color={failed === 0 ? "secondary" : "error"} showZero badgeContent={failed} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ResultButtonGroup;

export type TabNames = "all" | "copied" | "failed";
